import React from 'react';
import style from './block.module.scss';
import { BlockWrapper, defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableImg } from '@smartfire/components';

function Block() {
    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={style.grid}>
                    <EditableImg smartProp="img1" className={style.img} />
                    <EditableImg smartProp="img2" className={style.img} />
                </div>
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        img1: smartProps.image.withDefault({}),
        img2: smartProps.image.withDefault({}),
    },
    setup: {
        title: '2 images',
        icon: 'format-gallery',
    },
});
